export enum ServiceType {
    DOCSIS = 160,
    FTTX = 180,
}
